export default (ctx, inject) => {
  inject("dotdigital", {
    track(payload) {
      if (window?.dmPt) {
        payload ? window.dmPt("track", payload) : window.dmPt("track");
      }
    },
  });
};
